const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f5f7fa',
  },
  loginBox: {
    padding: '50px',
    borderRadius: '0.6cm',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '400px',
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  logo: {
    width: '75%',
  },
  socialMediaButtonsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '2rem',
  },
  socialMediaButton: {
    display: 'flex',
    gap: '10px',
    width: '100%',
    marginBottom: '1rem',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px',
    fontSize: '1rem',
    '&:hover': {
      opacity: 0.9,
    },
  },
};

export default styles;